module.exports = __webpack_public_path__ + "fonts/DM_Sans-900-latin19.3ccd9ab.woff2";